@use "variables" as *;

ul {
  padding: 0;
}

.mainDiv {
  width: 100%;
  height: 100%;
  display: flex;
  flex-grow: 1;
  overflow: auto;
}

.mainList {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.albumItemContainer {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.noSelectionDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.shortcutsTitle {
  font-size: $fontSize-ml;
  font-weight: bold;
  margin: $spacing-xxl $spacing-s $spacing-xl $spacing-s;
  text-align: center;
}
